module.exports = __webpack_public_path__ + "static/media/SY.5838065a.png";